import { render, staticRenderFns } from "./3_cctvPolicy.vue?vue&type=template&id=7c677c02&scoped=true&"
import script from "./3_cctvPolicy.vue?vue&type=script&setup=true&lang=js&"
export * from "./3_cctvPolicy.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./3_cctvPolicy.vue?vue&type=style&index=0&id=7c677c02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c677c02",
  null
  
)

export default component.exports